import React from 'react';

const Header = ({ companyName = "Yoga Studio", logoSrc = "/logo2.jpeg", bannerSrc = "/logo.jpeg" }) => {
  return (
    <header className="bg-gradient-to-r from-purple-700 to-indigo-800 text-white p-4 shadow-lg rounded-b-lg">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="flex items-center mb-4 md:mb-0">
          <img src={logoSrc} alt="Company Logo" className="h-12 w-12 mr-3 rounded-full border-2 border-white" />
          <h1 className="text-3xl font-extrabold tracking-tight">{companyName}</h1>
        </div>
        <div className="w-full md:w-auto">
          <img src={bannerSrc} alt="Yoga Banner" className="w-full h-24 object-cover rounded-lg shadow-md" onError={e => { e.target.onerror = null; e.target.src="https://placehold.co/800x200/667eea/ffffff?text=Yoga+Studio+Banner"; }} />
        </div>
      </div>
    </header>
  );
};

export default Header;
